import React from 'react'

import { AcornsIcon } from '@acorns/icons'
import { theme } from '@acorns/web-components'
import { motion } from 'framer-motion'
import styled from 'styled-components'

const StyledIcon = styled(AcornsIcon)`
  & > path {
    fill: ${theme.colors.charcoal};
  }
`

export const AgeOfTransferIndicator: React.FC<{
  width: number
}> = ({ width }) => {
  return (
    <motion.div
      animate={{
        opacity: 1,
      }}
      exit={{ opacity: 0 }}
      initial={{ opacity: 0 }}
      style={{
        left: '-2px',
        position: 'absolute',
        top: `-${width + 5}px`,
      }}
      transition={{
        duration: 0.7,
        ease: 'easeInOut',
      }}
    >
      <StyledIcon
        icon={AcornsIcon.Icon.IndicatorTriangleFv}
        height={width + 4}
        width={width + 4}
      />
    </motion.div>
  )
}
